export default class {

	constructor(obj) {
		this.id = obj.id
		this.name = obj.name
		this.localisation = obj.localisation
		this.link = obj.link
		this.typeParameter = obj.typeparameter
		this.typeId = obj.type_id
		this.xCoordinate = obj.xcoordinate
		this.yCoordinate = obj.ycoordinate
		this.code = obj.code
		this.cityId = obj.city_id
		this.creationDate = obj.creationdate
		this.updateDate = obj.updatedate
		this.lastUpdate = obj.lastUpdate
		this.watershedId = obj.watershed_id
		this.bssId = obj.bss_id
		this.sourceId = obj.source_id
		this.codeDce = obj.code_dce
		this.profondeur = obj.profondeur
		this.isPiezometer = obj.ispiezometer === '1'
		this.isQualitometer = obj.isqualitometer === '1'
		this.isHydrologicalStation = obj.ishydrologicalstation === '1'
		this.isPluviometer = obj.ispluviometer === '1'
		this.isTreatmentStation = obj.istreatmentstation === '1'
		this.isIndustrialSite = obj.isindustrialsite === '1'
		this.isSeaport = obj.isseaport === '1'
		this.isPollutedSoil = obj.ispollutedsoil === '1'
	}
}



// WEBPACK FOOTER //
// ./src/point/dto/DtoPoint.js